
/* eslint-disable no-nested-ternary */

import { CHANNEL, DEFAULT_THEME_MODE } from '../constants';
import '../types';

var defaultTheme = { mode: DEFAULT_THEME_MODE };

export default function getTheme(props) {
  return props && props.theme && props.theme[CHANNEL] ? props.theme[CHANNEL] : defaultTheme;
}


//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/@atlaskit/theme/dist/esm/utils/getTheme.js
// module id = 247
// module chunks = 0